import React, { useState } from "react";
import { SendOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  Spin,
  Row,
  Col,
  DatePicker,
  Input,
  Select,
  Checkbox,
} from "antd";
import "./InquiryForm.css";
import { UploadPhoto } from "./UploadPhoto";
import AdnLanguagePicker from "../common/adnLanguagePicker/AdnLanguagePicker";
import imagemLogoCirculo from "../../assets/images/logoProfileCirculo.png";
import moment from "moment";
import { dateFormat } from "../common/GeneralConfigurations";
import AdnThankYouComponent from "../common/adnThankYouComponent/AdnThankYouComponent";
import TermsCheckbox from "./TermsCheckbox";

const { TextArea } = Input;
const { Option } = Select;

export default function InquiryForm({
  fluencyLanguages,
  setFluencyLanguages,
  saveImage,
  disabledDate,
  employee,
  form,
  techs,
  handleFinish,
  invalidToken,
  image,
  birthDate,
  changeBirthDate,
  tech,
  changeTech,
  birthPlace,
  changeBirthPlace,
}) {
  const [checked, setChecked] = useState(false);

  return (
    <>
      {invalidToken === true ? (
        <AdnThankYouComponent isPTLanguage={!employee.isEmailEnglishLanguage} />
      ) : (
        <div className="container-wrapper">
          <div className="container">
            <Form
              form={form}
              initialValues={employee}
              name="advanced_search"
              layout="vertical"
              onFinish={handleFinish}
            >
              <div className="formBackground">
                <div className="formContainer">
                  {employee.birthDate === undefined ? (
                    <Spin style={{ marginTop: "50%" }}></Spin>
                  ) : (
                    <Col xs={24} className="inquiry-container">
                      <div className="logoCirculo">
                        <img src={imagemLogoCirculo} alt="" />
                      </div>

                      <Row gutter={16}>
                        <Col
                          xs={24}
                          sm={24}
                          md={24}
                          lg={8}
                          xl={8}
                          xxl={6}
                          className="container-profile-image"
                        >
                          <div className="profileImg">
                            <UploadPhoto
                              saveImage={saveImage}
                              imageUrl={image}
                            />
                          </div>
                          <label className="imageText">
                            {employee.isEmailEnglishLanguage
                              ? "Click the photo to switch"
                              : "Seleciona a foto para trocar"}
                          </label>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={16} xl={16} xxl={18}>
                          <Row>
                            <Col className="profileTitle">
                              <span id="profileWelcome">
                                {employee.isEmailEnglishLanguage
                                  ? "WELCOME"
                                  : "BEM-VINDO"}
                              </span>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <span id="profileName">
                                {employee.firstName} {employee.lastName}
                              </span>
                            </Col>
                          </Row>
                          <Row justify="space-between">
                            <Col>
                              <label className="header-label">
                                {employee.isEmailEnglishLanguage
                                  ? "/About"
                                  : "/Sobre"}
                              </label>
                            </Col>
                            <Col>
                              <Row align="middle">
                                <Col className="profileFluency">
                                  <label className="header-label">
                                    {employee.isEmailEnglishLanguage
                                      ? "Spoken languages:"
                                      : "Línguas faladas:"}
                                  </label>
                                </Col>
                                <Col>
                                  <AdnLanguagePicker
                                    setFluencyLanguages={setFluencyLanguages}
                                    fluencyLanguages={fluencyLanguages}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={24}>
                              <Form.Item
                                name={"professionalResume"}
                                rules={[
                                  {
                                    required: true,
                                    message: "Field is required",
                                  },
                                  {
                                    min: 150,
                                    message:
                                      "Resume must have minimum of 150 characters",
                                  },
                                ]}
                              >
                                <TextArea
                                  class="inputProfile"
                                  placeholder={
                                    employee.isEmailEnglishLanguage
                                      ? "Describe your professional trajectory (max: 300 chars)"
                                      : "Descreve o teu percurso profissional (max: 300 chars)"
                                  }
                                  autoSize={{ minRows: 3, maxRows: 4 }}
                                  maxLength={300}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row
                            className="profileExtraInfo"
                            justify="space-between"
                            gutter={12}
                          >
                            <Col
                              id="mainTech"
                              xs={24}
                              sm={24}
                              md={8}
                              lg={8}
                              xl={6}
                              xxl={6}
                            >
                              <Form.Item
                                name={"techSpecializedId"}
                                rules={[
                                  {
                                    validator: (rule, value, cb) => {
                                      tech == null
                                        ? cb("Field is required")
                                        : cb();
                                    },
                                  },
                                ]}
                              >
                                <Select
                                  placeholder={
                                    employee.isEmailEnglishLanguage
                                      ? "Role"
                                      : "Função"
                                  }
                                  allowClear
                                  onChange={changeTech}
                                >
                                  {techs &&
                                    techs.map((t) => (
                                      <Option
                                        className="optionTech"
                                        value={t.id}
                                      >
                                        {t.name}
                                      </Option>
                                    ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col
                              id="birthDate"
                              xs={24}
                              sm={24}
                              md={8}
                              lg={8}
                              xl={6}
                              xxl={6}
                            >
                              <Form.Item
                                name={"birthDate"}
                                rules={[
                                  {
                                    validator: (rule, value, cb) => {
                                      birthDate == null
                                        ? cb("Field is required")
                                        : cb();
                                    },
                                  },
                                ]}
                              >
                                <DatePicker
                                  className="adn-datepicker-inquiry"
                                  defaultPickerValue={moment(
                                    "2000-01-01",
                                    dateFormat
                                  )}
                                  style={{ width: "100%" }}
                                  placeholder={
                                    employee.isEmailEnglishLanguage
                                      ? "Birth Date"
                                      : "Data de nascimento"
                                  }
                                  disabledDate={disabledDate}
                                  value={birthDate}
                                  onChange={changeBirthDate}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={6} xxl={6}>
                              <Form.Item
                                name={"placeOfBirth"}
                                rules={[
                                  {
                                    validator: (rule, value, cb) => {
                                      birthPlace == null
                                        ? cb("Field is required")
                                        : cb();
                                    },
                                  },
                                ]}
                              >
                                <Input
                                  id="advanced_search_placeOfBirth"
                                  placeholder={
                                    employee.isEmailEnglishLanguage
                                      ? "Place of Birth"
                                      : "Local de nascimento"
                                  }
                                  autoComplete="off"
                                  maxLength={15}
                                  onChange={changeBirthPlace}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <Row className="questions">
                        <Col xs={24}>
                          <Row className="questionTextFormat">
                            {employee && employee.q1}
                          </Row>
                          <Row>
                            <Col xs={24}>
                              <Form.Item
                                name={"response1"}
                                rules={[
                                  {
                                    required: true,
                                    message: "Field is required",
                                  },
                                ]}
                              >
                                <TextArea
                                  id="AnswerInputFirst"
                                  autoSize={{ minRows: 2, maxRows: 2 }}
                                  maxLength={90}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24}>
                          <Row className="questionTextFormat">
                            {employee && employee.q2}
                          </Row>
                          <Row>
                            <Col xs={24}>
                              <Form.Item
                                name={"response2"}
                                rules={[
                                  {
                                    required: true,
                                    message: "Field is required",
                                  },
                                ]}
                              >
                                <TextArea
                                  id="AnswerInputSecond"
                                  autoSize={{ minRows: 2, maxRows: 2 }}
                                  maxLength={90}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24}>
                          <Row className="questionTextFormat">
                            {employee && employee.q3}
                          </Row>
                          <Row>
                            <Col xs={24}>
                              <Form.Item
                                name={"response3"}
                                rules={[
                                  {
                                    required: true,
                                    message: "Field is required",
                                  },
                                ]}
                              >
                                <TextArea
                                  id="AnswerInputThird"
                                  autoSize={{ minRows: 2, maxRows: 2 }}
                                  maxLength={90}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24}>
                          <Row className="questionTextFormat">
                            {employee && employee.q4}
                          </Row>
                          <Row>
                            <Col xs={24}>
                              <Form.Item
                                name={"response4"}
                                rules={[
                                  {
                                    required: true,
                                    message: "Field is required",
                                  },
                                ]}
                              >
                                <TextArea
                                  id="AnswerInputFourth"
                                  autoSize={{ minRows: 2, maxRows: 2 }}
                                  maxLength={90}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24}>
                          <Row className="questionTextFormat">
                            {employee && employee.q5}
                          </Row>
                          <Row>
                            <Col xs={24}>
                              <Form.Item
                                name={"response5"}
                                rules={[
                                  {
                                    required: true,
                                    message: "Field is required",
                                  },
                                ]}
                              >
                                <TextArea
                                  id="AnswerInputFifth"
                                  autoSize={{ minRows: 2, maxRows: 2 }}
                                  maxLength={90}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24}>
                          <Row className="questionTextFormat">
                            {employee && employee.q6}
                          </Row>
                          <Row>
                            <Col xs={24}>
                              <Form.Item
                                name={"response6"}
                                rules={[
                                  {
                                    required: true,
                                    message: "Field is required",
                                  },
                                ]}
                              >
                                <TextArea
                                  id="AnswerInputSixth"
                                  autoSize={{ minRows: 2, maxRows: 2 }}
                                  maxLength={90}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Item
                            name={"consent"}
                            rules={[
                              { required: true, message: "Field is required" },
                            ]}
                          >
                            <TermsCheckbox
                              isEmailEnglishLanguage={
                                employee.isEmailEnglishLanguage
                              }
                              checked={checked}
                              onChange={(e) => setChecked(e.target.checked)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row justify="end">
                        <Col xs={24} sm={12} md={8} lg={8} xl={4} xxl={4}>
                          <Button
                            disabled={!checked}
                            className="adn-primary-button inquiry-button"
                            type="primary"
                            htmlType="submit"
                            onClick={() => {
                              window.scrollTo({
                                top: 300,
                                left: 0,
                                behavior: "smooth",
                              });
                            }}
                          >
                            <SendOutlined />
                            {employee.isEmailEnglishLanguage
                              ? "Send"
                              : "Enviar"}
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  )}
                </div>
              </div>
            </Form>
          </div>
        </div>
      )}
    </>
  );
}
